import { addUserToTimeBasedCollection, findValidUser } from './firebaseUtils';

interface UserData {
  nickname: string;
  avatarNumber: string;
}

export const validateUser = async (nickname: string, avatarNumber: string): Promise<{ isValid: boolean; userData?: any }> => {
  try {
    
    const userData = await findValidUser(nickname, avatarNumber);
    
    if (userData) {
      return { isValid: true, userData };
    } else {
      return { isValid: false };
    }
  } catch (error) {
    console.error('사용자 유효성 검사 중 오류 발생:', error);
    return { isValid: false };
  }
};

export const saveUser = async (nickname: string, avatarNumber: string): Promise<boolean> => {
  try {
    
    const userData: UserData = {
      nickname,
      avatarNumber
    };
    
    
    const docId = await addUserToTimeBasedCollection(userData);
    return true;
  } catch (error) {
    console.error('사용자 데이터 저장 중 오류 발생:', error);
    return false;
  }
};

// 테스트용: 시간 제한 없이 검증하는 함수
export const validateUserWithoutTimeLimit = async (nickname: string, avatarNumber: string): Promise<boolean> => {
  try {
    
    // 이 함수는 시간 기반 검색을 사용하지 않으므로 주의가 필요합니다
    // 실제 구현 시에는 모든 시간대 컬렉션을 검색해야 할 수 있습니다
    
    return false;
  } catch (error) {
    console.error('시간 제한 없이 검증 중 오류 발생:', error);
    return false;
  }
};
